import { useTranslation } from "react-i18next";
import type { ProjectStatus } from "@/api/types";
import { cn } from "@/lib/utils";

const STEPS = ["discovery", "design", "build", "live"] as const;

/** Compact project stage for cards: four segments and a plain-language label. */
export function StageBar({ status }: { status: ProjectStatus }) {
  const { t } = useTranslation();
  const index = STEPS.indexOf(status as (typeof STEPS)[number]);
  const label =
    status === "requested"
      ? t("project.stageRequested")
      : index >= 0
        ? t("project.stage", { current: index + 1, total: STEPS.length, status: t(`project.status.${status}`) })
        : t("project.stageOff", { status: t(`project.status.${status}`) });
  return (
    <div className="flex flex-col gap-2">
      <div aria-hidden="true" className="flex gap-1">
        {STEPS.map((s, i) => (
          <span
            key={s}
            className={cn("h-1.5 flex-1 rounded-pill", i < index ? "bg-secondary" : i === index ? "bg-brand" : "bg-surface-sunken")}
          />
        ))}
      </div>
      <p className="text-sm text-fg-muted">{label}</p>
    </div>
  );
}
